import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom-v5-compat";

interface FeatureProtectedRouteProps extends PropsWithChildren {
  hasAccess: boolean;
  redirectTo: string;
}

const FeatureProtectedRoute = ({
  hasAccess,
  redirectTo,
  children,
}: FeatureProtectedRouteProps) => {
  if (!hasAccess) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default FeatureProtectedRoute;
